import type { ButtonProps } from '@chakra-ui/react';

import { ButtonLink } from '~/components/button-link';
import { trackEvent } from '~/features/analytics/track-event';
import { FormalDegreeKey } from '~/features/checkout/constants';
import { CircleArrowRightIcon } from '~/features/experiments/ab_plp_redesign_2025/icons';

import { RECOGNITION_OF_PRIOR_LEARNING_PATH, RPL_ANALYTICS_LABEL, RPL_CALCULATE_CTA } from '../constants';

export function RplCalculateButton({
  eventName,
  formalDegreeKey,
  width,
}: {
  eventName: string;
  formalDegreeKey?: FormalDegreeKey;
  width?: ButtonProps['width'];
}) {
  return (
    <ButtonLink
      linkProps={{ href: RECOGNITION_OF_PRIOR_LEARNING_PATH }}
      buttonProps={{
        colorScheme: 'blue',
        leftIcon: <CircleArrowRightIcon height='18px' width='18px' />,
        size: 'icon-left',
        variant: 'solid',
        width,
        onClick: () => {
          trackEvent({
            additionalAttributes: formalDegreeKey ? { formal_degree_key: formalDegreeKey } : undefined,
            label: RPL_ANALYTICS_LABEL.checkEligibility,
            name: eventName,
            type: 'click',
          });
        },
      }}
      isExternal
    >
      {RPL_CALCULATE_CTA}
    </ButtonLink>
  );
}
